import React, { Component } from 'react';
import $ from "jquery";
import { Link } from 'react-router-dom';

export class TimeOutNotification extends Component {
    constructor(props) {
        super(props);
        this.stayLoggedIn = this.stayLoggedIn.bind(this);
    }

    componentWillMount() {
    }

    render() {
        const logoutPath = { pathname: `/authentication/logout`, state: { local: true } };

        return (

            <div role="document" id="SessionExpireNotification" className="modal-dialog" style={{ marginTop: this.props.sessionState.marginTop, marginLeft: "25%", position: "absolute", display: "none" }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="modal-title h4">Need more time?</div>

                        <button type="button" className="close">
                            <span id="closeSpan" onClick={this.closeNotification} aria-hidden="true">×</span><span className="sr-only">Close</span>
                        </button>
                    </div><div className="modal-body">
                        <p> Your session is about to expire. You will be automatically signed out in</p>
                        <span id="logout-counter-span" style={{ fontSize: "xx-large" }} > 0{this.props.sessionState.sesExpNotMins}: 00</span>
                    </div>
                    <div className="modal-footer" style={{ justify: "space-between", display: "block" }}>

                        <button type="button" id="stay-logged-in-button" onClick={this.stayLoggedIn} className="btn btn-primary" style={{ backgroundColour: "rgb(0, 123, 255)", borderColor: "rgb(0, 123, 255)", marginLeft: "0px" }}>Stay Signed In</button>

                        <Link to={logoutPath}>
                            <button id="signout-button" className="btn btn-primary">Sign Out</button>
                        </Link>
                    </div>

                </div>
            </div>

        );
    }

    stayLoggedIn() {
        $('#SessionExpireNotification').css("display", "none");
        $('#SessionExpireNotification').css("display", "none");
        window['resetCounters'](this.props.sessionState.expireMins, this.props.sessionState.sesExpNotMins);
    }
    closeNotification() {
        $('#SessionExpireNotification').css("display", "none");
    }
}